import PrivatePhoto from "public/images/private-photo.png";

import { linkAssemblers } from "@/lib/unified-dtos/unified-media-mapper/helpers";
import { deepDeleteUndefined } from "@/utils/object.utils";

import { isPhoto } from "../../helpers/predicates";
import { LadyOwnPhoto, LadyProfileDto, LadyProfileDtoRaw } from "../../models";

export const mapData = (ladyDto: LadyProfileDtoRaw): LadyProfileDto => {
  const data = ladyDto;

  if (!data) return data;

  const picturePlug = (PrivatePhoto as StaticAssetWithSrc).src;
  const privatePhotoCount = data.forms.count_private_photo ?? 0;

  const placeholders = Array.from(
    { length: privatePhotoCount },
    (_, index) => ({
      photoSrcs: {
        small: picturePlug,
        medium: picturePlug,
        large: picturePlug,
      },
      type: "photo" as const,
      photoType: "HIDDEN_PRIVATE_PHOTO" as const,
      photoId: index + 1,
    }),
  );

  const mediaWithMeduimThumbnails = data.forms.media.map((item) => {
    if (isPhoto(item)) {
      const mediaName = item.mediaName;
      const isPrivatePhoto = item.photoType === "PRIVATE_PHOTO";

      return {
        ...item,
        photoSrcs: {
          large: linkAssemblers.safeMakePhotoUrl({
            mediaName,
            isPrivatePhoto: isPrivatePhoto,
          }),
          medium: linkAssemblers.safeMakePhotoThumbnailMedium({
            mediaName,
            isPrivatePhoto: isPrivatePhoto,
          }),
          small: linkAssemblers.safeMakePhotoThumbnailSmall({
            mediaName,
            isPrivatePhoto: isPrivatePhoto,
          }),
        },
      } satisfies LadyOwnPhoto;
    }
    return item;
  });

  const combinedMedia = [...mediaWithMeduimThumbnails, ...placeholders];

  const firstMedia: LadyOwnPhoto | undefined = isPhoto(combinedMedia[0])
    ? combinedMedia[0]
    : undefined;

  const breadCrumps = data.forms.breadCrumps?.map((item) => ({
    label: item.text,
    link: item.url,
  }));

  const result = {
    ...data,
    avatar: firstMedia,
    forms: { ...data.forms, breadCrumps, media: combinedMedia },
  };

  deepDeleteUndefined(result);

  return result;
};
